module.exports = __webpack_public_path__ + "static/logo-ca06fc18c96e4566a5e3b8e917e36550.svg";